<template>
    <u-tooltip-outlined-tile v-bind="$attrs">
        <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
            <slot :name="scopedSlotName" v-bind="slotData" />
        </template>
    </u-tooltip-outlined-tile>
</template>

<script>
import UTooltipOutlinedTile from "@/components/publish/styles/tooltips/u-tooltip-outlined-tile.vue";

export default {
    props: {},
    components: {
        UTooltipOutlinedTile,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
